import { http } from './common';

const assignClaim = async (options) => {
    return http.post(`/api/v2/cms/analysis/userassignment`, options);
};

const getClaimHistory = async (analysisId) => {
    return http.get(`/api/v2/cms/analysis/${analysisId}/userassignment/history`);
};

const getValidUsers = async (query=undefined) => {
    return http.get(`/api/v3/users/by-role${query ?  query:''}`);
};

export {
   assignClaim,
   getClaimHistory,
   getValidUsers
}